import ar from './ar.json';
import dk from './dk.json';
import en from './en.json';
import es from './es.json';
import zh from './zh.json';

interface LanguageConfig {
    [key: string]: {
        common: {
            en: string;
            dk: string;
            zh: string;
            ar: string;
            es: string;
            switchAccount: string;
            user: string;
            showAll: string;
            crypto: string;
            cryptoSpot: string;
            cryptoCFD: string;
            fxSpot: string;
            indexCFD: string;
            commCFD: string;
            futuresCFD: string;
            saveChanges: string;
            cancel: string;
            confirm: string;
            update: string;
            from: string;
            to: string;
            switch: string;
            review: string;
            max: string;
            general: string;
            tradeInfo: string;
            symbol: string;
            underlying: string;
            type: string;
            ccy: string;
            ccy1: string;
            ccy2: string;
            description: string;
            subType: string;
            mifidScope: string;
            priceDecimals: string;
            quantityDecimals: string;
            ccy2Enabled: string;
            minOrderSize: string;
            minOrderSizeCcy1: string;
            minOrderSizeCcy2: string;
            latencies: string;
            resetLayout: string;
            loading: string;
            search: string;
            reset: string;
            dateRange: string;
            startDate: string;
            endDate: string;
            requestStatus: string;
            nothingFound: string;
            instrumentInfo: string;
            back: string;
            yes: string;
            no: string;
            enabled: string;
            disabled: string;
            removeFromWatchlist: string;
            addToWatchlist: string;
            historicSearch: string;
            clear: string;
            unknownDate: string;
            toDateIsBeforeFromDate: string;
            remove: string;
            noOptionsFound: string;
            close: string;
        };
        navigation: {
            settings: string;
            logout: string;
            overview: string;
            deposits: string;
            withdrawals: string;
            trades: string;
            instruments: string;
            'bank accounts': string;
            wallets: string;
        };
        modules: {
            order: string;
            chart: string;
            blotter: string;
            balances: string;
            markets: string;
            'order-book': string;
            tickers: string;
            'account-value': string;
        };
        login: {
            title: string;
            username: string;
            password: string;
            loginButton: string;
            forgotPassword: string;
            termsOfBusiness: string;
            contactUs: string;
            helpAndResources: string;
            systemStatus: {
                operational: string;
                attempting: string;
                maintenance: string;
                outage: string;
            };
        };
        forgotPassword: {
            title: string;
            username: string;
            resetButton: string;
            backToLogin: string;
            successMessage: string;
            pleaseCheckEmail: string;
            didntReceiveEmail: string;
            resendIn: string;
        };
        resetPassword: {
            title: string;
            backToLogin: string;
            username: string;
            newPassword: string;
            confirmNewPassword: string;
            changePasswordButton: string;
            missingTokenError: string;
            passwordMismatchError: string;
            successMessage: string;
        };
        orderForm: {
            buy: string;
            sell: string;
            orderType: string;
            stopType: string;
            limitOrder: string;
            marketOrder: string;
            stopOrder: string;
            ocoOrder: string;
            price: string;
            limitPrice: string;
            stopPrice: string;
            stopLimitPrice: string;
            quantity: string;
            vwap: string;
            currentBest: string;
            bid: string;
            ask: string;
            spread: string;
            approx: string;
            total: string;
            slippage: string;
            duration: string;
            timeInForce: string;
            IOC: string;
            FOK: string;
            GTC: string;
            placeOrder: string;
            insufficientBalance: string;
            minOrderSize: string;
            orderSubmitted: string;
            orderFailed: string;
            pleaseEnsureAllInputsAreValid: string;
            clickOnceToEnableButton: string;
            clickToPlaceOrder: string;
            noSettlementDateAvailable: string;
        };
        orderBook: {
            vertical: string;
            horizontal: string;
            sizeAcc: string;
            size: string;
            price: string;
            tobSpread: string;
            spread: string;
            ask: string;
            bid: string;
            askSize: string;
            bidSize: string;
            noData: string;
        };
        blotters: {
            orders: string;
            trades: string;
            openPositions: string;
            showAll: string;
            filled: string;
            open: string;
            cancelled: string;
            orderId: string;
            status: string;
            instrument: string;
            orderType: string;
            side: string;
            ccy: string;
            qty: string;
            price: string;
            slippage: string;
            lastPrice: string;
            lastQty: string;
            avgPrice: string;
            stopPrice: string;
            cumQty: string;
            leavesQty: string;
            created: string;
            updated: string;
            account: string;
            user: string;
            executionType: string;
            tif: string;
            executionTime: string;
            type: string;
            fillPrice: string;
            avgFillPrice: string;
            ccy1: string;
            qty1: string;
            ccy2: string;
            qty2: string;
            executionId: string;
            fillNo: string;
            netQtyPosition: string;
            close: string;
            openPrice: string;
            currentPrice: string;
            unrealisedPnl: string;
            realisedPnl: string;
            valueDate: string;
            settlementDate: string;
            accountCode: string;
            amount: string;
            unrealisedPnlInBaseCurrency: string;
            date: string;
            method: string;
            noTableRecords: string;
            currentTradeDate: string;
            filters: string;
            searchResults: string;
            generalSearch: string;
            downloadData: string;
            instrumentType: string;
            refreshResults: string;
            rowsReturned: string;
            outOfAMaximum: string;
            fillInAboveCriteria: string;
            noOrdersFound: string;
            tradeId: string;
            tradeDate: string;
            subType: string;
            symbol: string;
            contraAmount: string;
            tradeLinkId: string;
            uti: string;
            expiryDate: string;
            optionStyle: string;
            optionType: string;
            optionVariant: string;
            fees: string;
            feesCcy: string;
            strikePrice: string;
            lowerBarrier: string;
            upperBarrier: string;
            fixApiSymbol: string;
            quantityDecimals: string;
            quantity1Decimals: string;
            quantity2Decimals: string;
            pipsDecimals: string;
            swapDecimals: string;
            valueDateConvention: string;
            cfi: string;
            upi: string;
            mifidScope: string;
            positionUtiPattern: string;
            tradeUtiPattern: string;
            ccy1Network: string;
            ccy1NetworkType: string;
            bankAccount: string;
            wallet: string;
            show: string;
        };
        balances: {
            settlementDate: string;
            currency: string;
            balance: string;
            total: string;
            unableToFetch: string;
            pleaseReachOut: string;
        };
        accountValue: {
            marginUsed: string;
            availableMargin: string;
            marginUsage: string;
            unrealizedPL: string;
            equity: string;
            cashBalance: string;
        };
        tickers: {
            collapse: string;
            expand: string;
            tools: string;
            watchlist: string;
            newWatchlist: string;
            editWatchlist: string;
            deleteWatchlist: string;
            actions: string;
            instrumentSelector: string;
            createWatchlist: string;
            startAddingTickers: string;
            areYouSureDeleteWatchlist: string;
            deletingWatchlistWillRemoveInstruments: string;
            thisActionCannotBeUndone: string;
            inputWatchlistName: string;
            editWatchlistName: string;
            order: string;
            noOrderBookData: string;
            noPrice: string;
        };
        lite: {
            convert: string;
            deposit: string;
            withdraw: string;
            yourBalances: string;
            asset: string;
            cryptoAssets: string;
            currency: string;
            fiatCurrencies: string;
            settlements: string;
            todaysMarket: string;
            marketMonitorSettings: string;
            arrangeTheCurrencies: string;
            icon: string;
            removeMarkets: string;
            finishedEditing: string;
            clickToAddMarkets: string;
            youMayArrange: string;
            addMarketMonitor: string;
            editMarketMonitor: string;
            pleaseSelectBaseCurrencyToMonitor: string;
            pleaseSelectBaseCurrency: string;
            pleaseSelectQuoteCurrency: string;
            nowSelectCurrencyAgainstBase: string;
            resetBaseCurrency: string;
            estimatedProceed: string;
            conversionRate: string;
            youHave: string;
            estimatedBalancesAfterConversion: string;
            confirmOrder: string;
            noPricesAvailable: string;
        };
        portal: {
            accountOverview: string;
            generateStatement: string;
            generateAccountStatement: string;
            selectTheDateRangeToBeIncluded: string;
            dateRange: string;
            startDate: string;
            endDate: string;
            format: string;
            pleaseNoteThatTheGeneratedStatement: string;
            current: string;
            history: string;
            assetClassAllocation: string;
            instrumentExposure: string;
            currencyExposure: string;
            currentBalances: string;
            currentOpenPositions: string;
            makeADeposit: string;
            bankTransfer: string;
            bankTransferDescription: string;
            cryptoTransfer: string;
            cryptoTransferDescription: string;
            standardSettlementInstructions: string;
            standardSettlementInstructionsDescription: string;
            depositHistory: string;
            requestAWithdrawal: string;
            bankAccountWithdrawal: string;
            bankAccountWithdrawalDescription: string;
            cryptoWallet: string;
            cryptoWalletDescription: string;
            internalTransfer: string;
            internalTransferDescription: string;
            withdrawalHistory: string;
            recentTrades: string;
            accountInstuments: string;
            addBankAccount: string;
            addWalletAddress: string;
            whitelistedBankAccounts: string;
            whitelistedWalletAddresses: string;
            recentRequestedTransactions: string;
            historicDate: string;
            backTo: string;
            account: string;
            actions: string;
            noBankAccountsWhitelistedYet: string;
            noWalletAddressesWhitelistedYet: string;
            depositViaBankTransfer: string;
            depositViaCryptoTransfer: string;
            requestDetails: string;
            supportDetails: string;
            supportDetailsFile: string;
            depositInformation: string;
            amountToDeposit: string;
            bankDetails: string;
            walletDetails: string;
            requestDescription: string;
            supportingInformation: string;
            supportingInformationOptional: string;
            transactionHash: string;
            dragOrClickToUpload: string;
            supportFileFormatsAre: string;
            attachedFileShouldNotExceed: string;
            nextStep: string;
            previousStep: string;
            submitRequest: string;
            fiatViaBankTransfer: string;
            cryptoViaWalletAddress: string;
            makeADepositFromYourWhitelistedBankAccount: string;
            makeADepositToYourWhitelistedWalletAddress: string;
            depositFunds: string;
            depositFiatDescription: string;
            depositCryptoDescription: string;
            transferFundsFromYourWhitelistedBankAccount: string;
            token: string;
            network: string;
            chain: string;
            address: string;
            beneficiaryName: string;
            bankName: string;
            bankAddress: string;
            branchName: string;
            accountNumber: string;
            ibanCode: string;
            swiftCode: string;
            notes: string;
            walletAddress: string;
            correspondentInformation: string;
            correspondentBankDetails: string;
            correspondentBankName: string;
            correspondentSwiftCode: string;
            intermediaryInformation: string;
            intermediaryBankDetails: string;
            intermediaryBankName: string;
            intermediarySwiftCode: string;
            noBankAccountInformationAvailable: string;
            noSupportedAssets: string;
            withdrawalViaBankTransfer: string;
            withdrawalViaCryptoTransfer: string;
            availableBalance: string;
            noAvailableBalance: string;
            selectAWithdrawalCurrency: string;
            selectAWithdrawalAsset: string;
            amountToWithdraw: string;
            makeAnInternalTransfer: string;
            transferType: string;
            amountToTransfer: string;
            fromAccount: string;
            toAccount: string;
            additionalInformation: string;
            proofOfOwnership: string;
            proofOfOwnershipOptional: string;
            generalInformation: string;
            friendlyName: string;
            bankAccountInformation: string;
            walletInformation: string;
            swiftBIC: string;
            swiftBICABARoutingNumber: string;
            walletType: string;
            networkInformation: string;
            tagMemo: string;
            termsAndConditions: string;
            vaspInformation: string;
            vasp: string;
            vaspLEN: string;
            vaspCountry: string;
            vaspLEI: string;
            vaspEmail: string;
            vaspAddress: string;
            assets: string;
            remark: string;
            bankAccountDetails: string;
            walletAddressDetails: string;
            invalidWalletAddressFormat: string;
            theFollowingWalletAddressRequested: string;
            doYouStillWishToSubmit: string;
            cancelBankAccountRequest: string;
            dismissBankAccountRequest: string;
            deactivateBankAccount: string;
            cancelWalletAddressRequest: string;
            dismissWalletAddressRequest: string;
            deactivateWalletAddress: string;
            areYouSureYouWantTo: string;
            cancelTheRequestFor: string;
            deactivate: string;
        };
        settings: {
            generalTab: string;
            tradingTab: string;
            notificationsTab: string;
            userTab: string;
            timezoneSettings: string;
            timezoneSettingsDescription: string;
            tradingLayoutSettings: string;
            tradingLayoutSettingsDescription: string;
            twoClickTradingSettings: string;
            twoClickTradingSettingsDescription: string;
            shortSellPreventionSettings: string;
            shortSellPreventionSettingsDescription: string;
            defaultMarketOrderDurationSettings: string;
            defaultMarketOrderDurationSettingsDescription: string;
            defaultLimitOrderDurationSettings: string;
            defaultLimitOrderDurationSettingsDescription: string;
            defaultStopOrderDurationSettings: string;
            defaultStopOrderDurationSettingsDescription: string;
            showNotificationsSettings: string;
            idleTimeoutSettings: string;
            idleTimeoutSettingsDescription: string;
            changePassword: string;
        };
        notifications: {
            all: string;
            unseen: string;
            seen: string;
            popUpsDisabledUntilNextLogin: string;
            markAllAsSeen: string;
            showMore: string;
            showingAllNotifications: string;
            noNotifications: string;
            dismiss: string;
            hideNotificationPopUpsUntilNextLogin: string;
            notificationsAreStillAvailable: string;
        };
    };
}

export default {
    en,
    dk,
    zh,
    ar,
    es
} as LanguageConfig;
